import GraphqlTypeJson from 'graphql-type-json'
import { Field, InputType } from '@nestjs/graphql'
import { prop } from '@typegoose/typegoose'
import { ActionHint, Bet, BotKind, GameModeTag, PlayerKind, PlayKind } from '@ppwr/poker'
import { PausableStepFunctionInput } from '../../stepFunctions'

@InputType('GameCommand')
export class GameCommand {
  @Field()
  public userId: string = ''

  @Field()
  public channelName: string = ''

  @Field(() => GameModeTag, { nullable: true })
  public kind?: GameModeTag
}

@InputType('CheckForBotsGameCommand')
export class CheckForBotsGameCommand extends GameCommand {
  @Field()
  public interval?: string
}

@InputType('PauseGameCommand')
export class PauseGameCommand extends GameCommand {
  @Field()
  public skipChat?: boolean
}

@InputType('GameStartOptions')
export class GameStartOptions {
  @Field(() => GameModeTag)
  public mode: GameModeTag = GameModeTag.default
  // DEPRECATED PARAM: Making api backwards compatible (unused param)
  @Field({ nullable: true })
  public blindMultipler?: number
  // END DEPRECATED PARAM
  @Field()
  public blindTimerCountdown: number = 5
}

@InputType('GameStartCommand')
export class GameStartCommand extends GameCommand {
  @Field(() => Boolean)
  public enableAutoStart = false

  @Field({ nullable: true })
  public options?: GameStartOptions
}

@InputType('JoinGameCommand')
export class JoinGameCommand extends GameCommand {
  @Field(() => String)
  public playerName = ''

  @Field({ nullable: true })
  public startingChips?: number

  @Field(() => PlayKind, { nullable: true })
  public playKind?: PlayKind

  @Field(() => PlayerKind, { nullable: true })
  public playerKind?: PlayerKind

  @Field(() => BotKind, { nullable: true })
  public botKind?: BotKind
}

@InputType('AddBotsCommand')
export class AddBotsCommand extends GameCommand {
  @Field(() => Number)
  public botCount = 1

  @Field({ nullable: true })
  public startingChips?: number
}

@InputType('PlayerCommand')
export class PlayerCommand extends GameCommand {
  @Field()
  public playerId: string = ''
}

@InputType('TableCommand')
export class TableCommand extends GameCommand {
  @Field()
  public playerId: string = ''
}

@InputType('BlindCommand')
export class BlindCommand extends TableCommand {
  @Field()
  public blindLevel: number = 0
}
@InputType('BetCommand')
export class BetCommand extends GameCommand {
  @Field(() => GraphqlTypeJson)
  public bet?: Bet
  @Field()
  public playerId: string = ''
}

@InputType('BuyCommand')
export class BuyCommand extends GameCommand {
  @Field()
  public amount: number = 0
  @Field()
  public playerId: string = ''
  @Field({ nullable: true, defaultValue: false })
  @prop({ default: false })
  public hasPendingBuys?: boolean
  @Field({ nullable: true, defaultValue: false })
  @prop({ default: false })
  public givenByTeacher?: boolean
}

@InputType('BuyForAllPlayersCommand')
export class BuyForAllPlayersCommand extends GameCommand {
  @Field()
  public amount: number = 0
  @Field({ nullable: true, defaultValue: false })
  @prop({ default: false })
  public hasPendingBuys?: boolean
}

@InputType('NoActionCommand')
export class NoActionCommand extends TableCommand {
  @Field(() => [ActionHint], { nullable: true })
  public actions?: ActionHint[]
  public boardStateToRemoveExecution?: string
}

@InputType('TestDeadLetterQueueCommand')
export class TestDeadLetterQueueCommand {
  @Field(() => String)
  public test = 'test'
}

@InputType('SleepGameCommand')
export class SleepGameCommand {
  @Field()
  public channelName?: string

  public payload?: PausableStepFunctionInput
}

export type GameEventContractCommands =
  | BetCommand
  | BuyCommand
  | TableCommand
  | NoActionCommand
  | JoinGameCommand
  | PauseGameCommand
  | GameStartCommand
  | SleepGameCommand
  | GameCommand
  | TestDeadLetterQueueCommand
  | CheckForBotsGameCommand
  | AddBotsCommand
